import tinycolor from "tinycolor2"; // eslint-disable-next-line import/prefer-default-export

export function generateColorScale(baseColor, lightMixColor, darkMixColor) {
  if (lightMixColor === void 0) {
    lightMixColor = "#fff";
  }

  return {
    "25": tinycolor.mix(baseColor, lightMixColor, 93).toHexString(),
    "50": tinycolor.mix(baseColor, lightMixColor, 88).toHexString(),
    "100": tinycolor.mix(baseColor, lightMixColor, 70).toHexString(),
    "200": tinycolor.mix(baseColor, lightMixColor, 50).toHexString(),
    "300": tinycolor.mix(baseColor, lightMixColor, 30).toHexString(),
    "400": tinycolor.mix(baseColor, lightMixColor, 15).toHexString(),
    "500": baseColor,
    "600": tinycolor.mix(baseColor, darkMixColor, 15).toHexString(),
    "700": tinycolor.mix(baseColor, darkMixColor, 30).toHexString(),
    "800": tinycolor.mix(baseColor, darkMixColor, 50).toHexString(),
    "900": tinycolor.mix(baseColor, darkMixColor, 70).toHexString()
  };
}